import axios from "@/axios.js"
import Contacts from './contacts_service'
export default {
  getContact({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/contacts/search_contact/" + item)
        .then((response) => {
          commit('SET_CONTACT', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getContactsMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_account_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllDataBuildContactsForClientSide({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/get_all_data_build_contacts_client_side", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateOtherFieldContactData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/update_other_field_contact_data", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getMasterMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_master_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSatelliteOfficeMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_satellite_office_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getWebMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_web_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getLinkedinMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_linkedin_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPhoneMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_phone_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSicCodeMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_siccode_metadata/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getVertical({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/contacts/get_vertical/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getCountry({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/contacts/get_country/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getParent({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/contacts/${item}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getGroupCompanies({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/contacts/get_grouped_companies/${item}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  checkLinkedinExists({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/check_linkedin_exists", {
        item: item
      })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  checkWebsiteExists({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/check_website_exists", {
        item: item
      })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  checkCompanyExists({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/check_company_exists", {
        item: item
      })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchAutocomplete({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/contacts/search_contact/" + item)
        .then((response) => {
          // // console.log(response)
          commit('SET_AUTOCOMPLETE_DATA', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateContact({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/update_contact", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateRebuildContact({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/update_rebuild_contact", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateContactAndMoveToOtherAccount({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/update_contact_and_move_to_other_account", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateGrade3RebuildContact({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/update_grade_3_rebuild_contact", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPhoneTypes({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/contacts/phone_types")
        .then((response) => {
          // // console.log(response)
          commit('SET_PHONE_TYPES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getVerticals({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/contacts/verticals/" + item)
        .then((response) => {
          commit('SET_VERTICALS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getCountries({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/contacts/countries/" + item)
        .then((response) => {
          commit('SET_COUNTRIES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllContacts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      // console.log(item1)
      axios.get("/api/contacts/" + item.page_no + "/" + item.per_page)
        .then((response) => {
          commit('SET_CONTACTS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchContact({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/fetch_contact", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchContactForRebuild({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/fetch_contact_for_rebuild ", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchGrade3ContactForRebuild({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/fetch_grade_3_contact_for_rebuild ", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchContactList({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/contacts/${item}`)
        .then((response) => {
          commit('SELECTED_ACCOUNT', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeContact({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/contacts/delete_contact/" + item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllContactsForCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Contacts.getData(item, (rows, lastRow) => {
        console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
      });
    })
  },
  fetchAllContactsOfContactsForCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Contacts.getDataOfSelectedContact(item, (rows, lastRow) => {
        console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
      });
    })
  },
  getSeniority({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/contacts/get_seniority")
        .then((response) => {
          // // console.log(response)
          commit('SET_SENIORITIES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getRoles({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/contacts/get_roles")
        .then((response) => {
          // // console.log(response)
          commit('SET_ROLES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSubRoles({
    commit
  }, roleId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/contacts/sub_roles/${roleId}`)
        .then((response) => {
          commit('SET_SUB_ROLES', roleId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSubRolesByName({
    commit
  }, roleName) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/contacts/sub_roles_by_name/${roleName}`)
        .then((response) => {
          commit('SET_SUB_ROLES', roleName)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addContacts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/add_contacts", {
        item: item
      })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  validateEmailZeroBounce({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/validate_email_zero_bounce", {
        item: item
      })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addContactsToAddInCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/add_contacts_to_add_in_campaign", {
        item: item
      })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  buildContactToAccountAndAddToCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/build_contact_to_account_and_add_to_campaign", {
        item: item
      })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  rebuildContactToAccountAndAddToCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/rebuild_contact_to_account_and_add_to_campaign", {
        item: item
      })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addContactToMasterDBAndMoveToOtherAccount({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/add_contact_to_master_db_and_move_to_other_account", {
        item: item
      })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addRequestAccountContactBySD({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/add_request_account_contact_by_sd", {
        item: item
      })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addRequestContactBySD({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/add_request_contact_by_sd", {
        item: item
      })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllDBContacts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Contacts.getAllDBData(item, (rows, lastRow) => {
        console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
      });
    })
  },
  getEmailExistsInDB({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Contacts.getEmailExistsDBData(item, (rows, lastRow) => {
        resolve({ rows: rows, lastRow: lastRow })
      });
    })
  },
  getUnassociatedContacts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Contacts.getUnassociatedContacts(item, (rows, lastRow) => {
        resolve({ rows: rows, lastRow: lastRow })
      });
    })
  },
  unassociatedContactsWithAccounts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Contacts.unassociatedContactsWithAccounts(item, (rows, lastRow) => {
        resolve({ rows: rows, lastRow: lastRow })
      });
    })
  },
  enrichContactDataToMasterDB({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Contacts.enrichContactDataToMasterDB(item, (rows, lastRow) => {
        resolve({ rows: rows, lastRow: lastRow })
      });
    })
  },
  updateMasterDBContact({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/update_master_db_contact", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  ignoreMasterDBContact({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/ignore_master_db_contact", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  ignoreMasterDBContactFromValidateSDContact({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/ignore_master_db_contact_from_validate_sd_contact", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  ignoreMasterDBContactFromValidateClientView({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/ignore_master_db_contact_from_validate_client_view", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateOldCsvContactData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/update_old_csv_contact_data", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  ignoreCsvContactNewData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/ignore_new_csv_contact_data", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  IgnoreUpdateToContactField({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/ignore_contact_field_data", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addContactAndAddToCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/add_contacts_and_add_to_campaign", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  dropContactsFromCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/drop_contacts_from_campaign", {
        item: item
      })
        .then((response) => {

          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateHasDifferentValueAfterUpdate({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/has_different_value_after_update_flag", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateMasterDBContactFromCompare({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/update_master_db_contact_from_compare", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateMasterDBContactFromSDValidate({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/update_master_db_contact_from_sd_validate", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateMasterDBContactFromClientViewValidate({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/update_master_db_contact_from_client_view_validate", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPotentialMatchesForDataBuild({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/get_potential_matches_for_data_build", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })

  },
  getExistingCampaignContactMatches({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/get_existing_campaign_contact_matches", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })

  },
  getExistingMasterDatabaseContactsMatches({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/get_existing_master_database_contacts", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })

  },
  getExistingMasterDatabaseContactsMatchesFromCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/get_existing_master_database_contacts_from_campaign", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })

  },
  getAllExistingMasterDatabaseContactsMatches({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/get_all_existing_master_database_contacts", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })

  },
  getAllExistingMasterDatabaseContactsMatchesWithCampaignIndication({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/get_all_existing_master_database_contacts_with_campaign_indication", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })

  },
  getCorrectionFields({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/get_correction_fields", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })

  },
  buildcontactAndAddToCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/build_contact_and_add_to_campaign", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  buildExistingMasterDatabaseContactsToCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/build_existing_master_database_contacts_to_campaign", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  MoveExistingContactToThisCampaignFromAnotherAccountToThisAccount({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/move_existing_contact_to_this_campaign_from_another_account_to_this_account", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addThisContactToCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/add_this_contact_to_campaign", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addExistingMasterDatabaseContactsToCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/add_existing_master_db_contact_to_campaign", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addNewContactToThisCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/add_new_contact_to_this_campaign", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  contactBuildComplete({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/contact_build_complete", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  accountRebuildComplete({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/account_rebuild_complete", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  contactRebuildComplete({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/contact_rebuild_complete", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  AccountContactRequestComplete({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/account_contact_request_complete", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getDataAdministratorContactDataSource({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/get_data_administrator_contact_data_source", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateDataBuildMasterDBContact({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/update_data_build_master_db_contact", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  buildcontactAndAddToCampaignAnyway({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/build_contact_and_add_to_campaign_anyway", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })

  },
  getMatchedEmails({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/get_matched_emails", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })

  },
  getMatchedSocialMedias({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/get_matched_social_medias", {
        item: item
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })

  },
  updateContactDescriptionAndAddToCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/update_contact_description_and_add_to_campaign", {
        item: item
      })
        .then((response) => {
          // // console.log(response)
          commit('ADD_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateRequestContactToMasterDB({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/update_request_contact_to_master_db", {
        item: item
      })
        .then((response) => {
          // // console.log(response)

          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  AddMatchedNoneCoreFields({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/contacts/add_matched_none_core_fields", {
        item: item
      })
        .then((response) => {

          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
